<vp-carousel
	[alignment]="alignment()"
	[contentMargin]="contentMargin()"
	[editableInStoryblok]="_editable()"
	[items]="carouselItems"
	[verticalAlignment]="verticalAlignment()"
/>
